import { render, staticRenderFns } from "./SchoolDetail.vue?vue&type=template&id=4cfd6d32&scoped=true&"
import script from "./SchoolDetail.vue?vue&type=script&lang=js&"
export * from "./SchoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDetail.vue?vue&type=style&index=0&id=4cfd6d32&prod&lang=stylus&scoped=true&"
import style1 from "./SchoolDetail.vue?vue&type=style&index=1&id=4cfd6d32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd6d32",
  null
  
)

export default component.exports